import React from "react";

import { IconButton } from "@/components/elements/Button";
import { useSidebar } from "@/components/elements/Sidebar";
import WeldLogo from "@/components/elements/Weldlogo";
import classNames from "@/helpers/classNames";
import { MenuIcon } from "lucide-react";

export default function MobileHeader({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const { toggleSidebar } = useSidebar();
  return (
    <div
      className={classNames(
        "flex items-center gap-4 border-b bg-background py-2 pr-4 pl-3 md:hidden dark:bg-gray-900",
        className,
      )}
      {...props}
    >
      <IconButton
        size="sm"
        variant="ghost"
        icon={<MenuIcon className="size-6" />}
        onClick={() => toggleSidebar()}
      />
      <div className="ml-auto flex shrink-0 items-center">
        <WeldLogo className="h-3" />
      </div>
    </div>
  );
}
